import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ErrorWord } from 'views/templates/accountOpen/common';
import { useToast } from 'views/mutual/toast/hooks';
import { ToastMessageLevel } from 'views/mutual/toast';
import { PagePath } from 'constants/pagePath';
import { useLocation } from 'react-router-dom';
import { useAuthHandler } from 'views/auth/useAuth';
import { useSmsCertificateMutation } from 'views/utils/graphql/graphql';
import useOnceSubmit from 'views/utils/useOnceSubmit';


export type ActivationType = {
    activationCode: string;
}
export const useActivationCode = () => {
  const location = useLocation();
  const state = location.state as { provisionalToken: string };
  const { toastProps, showToast } = useToast();
  const { onSmsCertificatedSuccess } = useAuthHandler();
  const [, smsCertificate] = useSmsCertificateMutation();

    const validation = Yup.object().shape({
    activationCode: Yup.string()
      .required(ErrorWord.INPUT)
      .matches(/^[A-Za-z0-9]{4}$/, '英数字4桁で入力してください'),
  });

    const initialValues: ActivationType = {
        activationCode: '',
    };

    const onSubmit = useOnceSubmit<ActivationType>(
    {
      onSubmit: async (values) => {
        const ret = await smsCertificate({
          input: {
            Type: 4,
            ProvisionalToken: state.provisionalToken,
            AuthenticationCode: values.activationCode,
          },
        });

        if (ret.data?.SMSCertificate?.Code !== 0) {
          showToast(ret.data?.SMSCertificate?.Message ?? '認証に失敗しました', ToastMessageLevel.Error);
        } else {
          onSmsCertificatedSuccess(ret.data.SMSCertificate.Token!);
        }
      },
    },
    [showToast],
  );

  const formik = useFormik<ActivationType>({
    initialValues,
    onSubmit: onSubmit,
    validationSchema: validation,
    validateOnChange: false,
    validateOnBlur: false,
  });

    const activationCodeProps = {
    selected: formik.values.activationCode,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => formik.setFieldValue('activationCode', event.target.value),
  };

    return {formik, activationCodeProps, toastProps}
}